<header class="navbar" [class.scrolled]="scrolled()">
  <div class="container navbar__inner">

    <!-- Logo -->
    <a href="#" class="navbar__logo">
      <span class="logo-icon">
        <svg width="38" height="38" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <polygon points="50,4 53.5,50 50,42 46.5,50" fill="white"/>
          <polygon points="50,96 53.5,50 50,58 46.5,50" fill="white" opacity="0.7"/>
          <polygon points="96,50 50,46.5 58,50 50,53.5" fill="white" opacity="0.7"/>
          <polygon points="4,50 50,46.5 42,50 50,53.5" fill="white" opacity="0.7"/>
          <polygon points="79,21 53,50 56,47" fill="white" opacity="0.5"/>
          <polygon points="21,21 47,50 44,47" fill="white" opacity="0.5"/>
          <polygon points="79,79 53,50 56,53" fill="white" opacity="0.5"/>
          <polygon points="21,79 47,50 44,53" fill="white" opacity="0.5"/>
          <circle cx="50" cy="50" r="20" stroke="rgba(255,255,255,0.35)" stroke-width="1" fill="none"/>
          <circle cx="50" cy="50" r="28" stroke="rgba(255,255,255,0.2)" stroke-width="0.8" fill="none"/>
          <circle cx="50" cy="50" r="5" fill="white"/>
          <circle cx="50" cy="50" r="2.5" fill="#0a1628"/>
        </svg>
      </span>
      <span class="logo-text">NAUTIS <em>VISION</em></span>
    </a>

    <!-- Nav links (desktop) -->
    <nav class="navbar__nav" [class.open]="menuOpen()">
      <ul class="navbar__links">
        <li><a href="#home"       (click)="closeMenu()">{{ t().nav_home }}</a></li>
        <li><a href="#solutions"  (click)="closeMenu()">{{ t().nav_solutions }}</a></li>
        <li><a href="#offshore"   (click)="closeMenu()">{{ t().nav_offshore }}</a></li>
        <li><a href="#detections" (click)="closeMenu()">{{ t().nav_detections }}</a></li>
        <li><a href="#events"     (click)="closeMenu()">{{ t().nav_events }}</a></li>
        <li><a href="#use-cases"  (click)="closeMenu()">{{ t().nav_use_cases }}</a></li>
        <li><a href="#technology" (click)="closeMenu()">{{ t().nav_tech }}</a></li>
        <li><a href="#about"      (click)="closeMenu()">{{ t().nav_about }}</a></li>
        <li><a href="#contact" class="nav-cta" (click)="closeMenu()">{{ t().nav_contact }}</a></li>
      </ul>
    </nav>

    <!-- Lang Switcher + Hamburger -->
    <div class="navbar__right">
      <app-lang-switcher />
      <button class="hamburger" [class.active]="menuOpen()" (click)="toggleMenu()" aria-label="Menu">
        <span></span><span></span><span></span>
      </button>
    </div>

  </div>
</header>